(ns practitest.frontend.common-entities.delete-confirmation-modal
  (:require
   [practitest.frontend.common-entities.events :as events]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.confirmation :as confirmation]
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]))

(defn delete-confirmation-modal
  "Shared 'delete the entity I'm viewing' confirmation modal for own-form Delete
   menu items. :on-confirm is the delete dispatch to run once confirmed."
  [{:keys [entity title entity-name on-confirm]}]
  (let [show? @(re-frame/subscribe [::events/entity-delete-confirmation entity])]
    [confirmation/confirm
     {:show? (reagent/atom (boolean show?))
      :title title
      :body (get-translation "entity.confirm.action-delete" "Are you sure? This Operation cannot be undone.")
      :yes-label (get-translation "generic.button.delete" "Delete")
      :no-label (get-translation "generic.button.cancel" "Cancel")
      :on-yes (fn []
                (re-frame/dispatch [::events/close-entity-delete-confirmation entity])
                (on-confirm))
      :on-no #(re-frame/dispatch [::events/close-entity-delete-confirmation entity])
      :test-id "delete-confirm-btn"
      :dialog-test-id "delete-confirm-dialog"
      :entity-name entity-name
      :destructive? true
      :close-on-escape? true}]))

(defn open! [entity]
  (re-frame/dispatch [::events/open-entity-delete-confirmation entity]))
